<template>
    <div class="bg-white">
        <Hero :title="$t('news.title')" :lead="$t('news.lead')" class="relative z-0" overlapped-by-content />

        <div id="news-content" class="text-black pb-20 -mt-28 lg:-mt-32 relative z-10">
            <div class="container">
                <div v-if="featuredArticles && featuredArticles.length" class="grid grid-cols-12 gap-5 mb-20">
                    <div
                        v-for="article in featuredArticles"
                        :key="article.id"
                        class="col-span-12 sm:col-span-6 lg:col-span-4 4xl:col-span-3"
                    >
                        <ArticleCard
                            :url="localePath(`/news/${article.slug}`)"
                            :title="article.title"
                            :description="article.lead"
                            :minutes-to-read="article.minutes_to_read"
                            :thumbnail="article.cover_image_cropped"
                        />
                    </div>
                </div>
                <div v-else class="py-14"></div>

                <div v-if="articles && articles.length">
                    <div class="flex justify-between items-start mb-12">
                        <h2 class="title title-lg decor-underline decor-underline--magenta">{{ $t('news.title') }}</h2>
                        <Pagination
                            :pages-count="pagesCount"
                            :page="$route.query.page ? +$route.query.page : 1"
                            light-theme
                            class="mb-8 mt-2"
                        />
                    </div>

                    <div class="grid grid-cols-12 gap-x-5 gap-y-10">
                        <div
                            v-for="article in articles"
                            :key="article.id"
                            class="col-span-12 sm:col-span-6 lg:col-span-4 4xl:col-span-3"
                        >
                            <ArticleCard
                                :url="localePath(`/news/${article.slug}`)"
                                :title="article.title"
                                :description="article.lead"
                                :thumbnail="article.cover_image_cropped"
                                :minutes-to-read="article.minutes_to_read"
                                class="border-none"
                                theme="light"
                            />
                        </div>
                    </div>

                    <Pagination
                        :pages-count="pagesCount"
                        :page="$route.query.page ? +$route.query.page : 1"
                        class="mt-10"
                        light-theme
                        scroll-target="#news-content"
                    />
                </div>
                <div v-else class="py-16">{{ $t('generic.no_results') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Hero from '@/components/Heroes/Hero';
import ArticleCard from '~/components/Cards/ArticleCard/ArticleCard';
import Pagination from '@/components/UI/Pagination';

export default {
    name: 'Index',
    components: {
        Hero,
        ArticleCard,
        Pagination,
    },
    async asyncData({ $axios, route, error, i18n, localePath, redirect, $getIsLangKoZhDe }) {
        if ($getIsLangKoZhDe()) {
            return redirect(localePath('/'));
        }

        let articles = null;
        let featuredArticles = null;
        let pagesCount = null;

        const ITEMS_PER_PAGE = 12;

        const offset = route.query.page ? (route.query.page - 1) * ITEMS_PER_PAGE : '';

        try {
            await Promise.all([
                $axios.$get(`/article?highlighted=0&limit=${ITEMS_PER_PAGE}&offset=${offset}`),
                $axios.$get('/article?highlighted=1&limit=3'),
            ])
                .then(([articlesRes, featuredArticlesRes]) => {
                    if (articlesRes.total && !articlesRes.data.length) {
                        return error({ statusCode: 404, message: i18n.t('error.page_not_found.title') });
                    }

                    if (articlesRes.success === 1) {
                        articles = articlesRes.data;
                        pagesCount = Math.ceil(articlesRes.total / ITEMS_PER_PAGE);
                    }

                    if (featuredArticlesRes.success === 1) {
                        featuredArticles = featuredArticlesRes.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
        }

        return { articles, featuredArticles, pagesCount };
    },
    head() {
        return {
            title: this.$t('news.title'),
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.$getOgTitle(this.$t('news.title')),
                },
                {
                    hid: 'title',
                    name: 'title',
                    content: this.$getOgTitle(this.$t('news.title')),
                },
            ],
        };
    },
    watchQuery: true,
    // beforeMount() {
    //     window.scrollTo(0, 0);
    // },
    mounted() {
        this.$store.commit('news/setLastSearchQuery', this.$route.query);
    },
};
</script>

<style scoped></style>
